<template>
  <div>
    <div class="search-content">
      <el-col :span="24" class="toobar">
        <el-input style="width:200px;"
                  placeholder="请输入名称"
                  prefix-icon="el-icon-search"
                  clearable
                  @clear="bindGrid"
                  v-model="searchdata" @keyup.enter.native="bindGrid">
        </el-input>
        <el-select v-model="isenabled" placeholder="启用状态" @change="bindGrid" :clearable="false">
          <el-option  label="启用中" value="1"></el-option>
          <el-option  label="即将到期" value="2"></el-option>
          <el-option  label="已失效" value="3"></el-option>
        </el-select>
        <el-select v-model="directstore" placeholder="门店所属" @change="bindGrid" :clearable="true">
          <el-option  label="直营" value="1"></el-option>
          <el-option  label="非直营" value="-1"></el-option>
        </el-select>
        <el-button type="warning" v-on:click="add" v-if="false">新增</el-button>
      </el-col>
    </div>
    <el-table
      :data="tableData"
      :height="tableHeight()"
      size="mini"
      stripe
      border
      style="width: 100%;">
      <el-table-column
        width="50"
        label="序号"
        align="center">
        <template slot-scope="scope">
          {{1+scope.$index+(pagination.currentPage-1)*pagination.pageSize}}
        </template>
      </el-table-column>
      <el-table-column
        prop="tenantname"
        align="left" header-align="center"
        label="名称" >
        <template slot-scope="scope">
          {{scope.row.tenantname}}<el-tag v-if="scope.row.directstore==1" size="mini">直营</el-tag>
        </template>
      </el-table-column>
      <el-table-column
        prop="minidiscount"
        label="最低折扣"
        align="center"
        width="70">
      </el-table-column>
      <el-table-column
        prop="website"
        label="网址"
        align="left">
      </el-table-column>
      <el-table-column
        prop="params"
        label="功能"
        align="left" header-align="center">
        <template slot-scope="scope">
          {{scope.row.params?JSON.parse(scope.row.params).module:''}}
        </template>
      </el-table-column>
      <el-table-column
        prop="contactname"
        label="管理员"
        align="center"
        width="100">
      </el-table-column>
      <el-table-column
        prop="contactphone"
        label="手机号"
        align="center" width="200">
      </el-table-column>
      <el-table-column
        prop="enddatetime"
        label="有效期"
        width="120"
        align="center">
        <template slot-scope="scope">
          {{scope.row.enddatetime.toString().substr(0,10)}}
        </template>
      </el-table-column>
      <el-table-column
        prop="adddate"
        label="添加日期"
        width="170"
        align="center">
      </el-table-column>
      <el-table-column
        prop="unitguid"
        align="left" header-align="center"
        label="唯一码" width="250" >
      </el-table-column>
      <el-table-column label="操作" align="center" width="70">
        <template slot-scope="scope">
          <el-button
            size="mini"
            @click="handleEdit(scope.$index, scope.row)">编辑
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <div class="foot">
      <Pagination ref="pagination1" @bindgrid="bindGrid" :pagination="pagination"></Pagination>
    </div>
    <ManageTenantEdit ref="manageTenantEdit" @bindGuid="bindGrid"></ManageTenantEdit>
  </div>
</template>

<script>
  import {sysmanageList} from '@/api/sysmanage/sysmanage'
  import {updateData, getLogListData} from '@/api/set/handlelog';
  import ManageTenantEdit from './ManageTenantEdit'

  export default {
    name: 'ManageTenant',
    data() {
      return {
        dialogFormVisible: false,
        searchdata: "",
        dname: "",
        fdpath: "",
        loading: true,
        isenabled: '1',
        directstore: '',
        pagination: {
          currentPage: 1,
          pageSize: 0,
          total: 0
        },
        tableData: [],
      }
    },
    methods: {
      //添加
      add() {
        this.$refs.manageTenantEdit.show()
      },
      //编辑
      handleEdit(index, row) {
        this.$refs.manageTenantEdit.initData(row.unitguid)
        this.$refs.manageTenantEdit.show()
      },
      bindGrid() {
        var row={
          offset: (this.pagination.currentPage - 1) * this.pagination.pageSize,
          limit: this.pagination.pageSize,
          directstore:this.directstore,
          tenantname: this.searchdata,
        };
        if(this.isenabled==1){
          row.inuser=1;
        }else if(this.isenabled==2){
          row.isnearendtime=1;
        }else if(this.isenabled==3) {
          row.isoverendtime = 1;
        }
        sysmanageList(row).then(response => {
          this.tableData = response.data.obj.rows;
          this.pagination.total = response.data.obj.total;
        }).catch((error) => {
          console.log(error)
        });
      },

    },
    mounted() {
      this.bindGrid();
    },
    components: {
      ManageTenantEdit
    }

  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

  /*.el-table td, .el-table div, .el-table .cell {*/
  /*line-height: 23px;*/
  /*padding: 0px;*/
  /*color: red;*/
  /*}*/

</style>



// WEBPACK FOOTER //
// src/components/sysmanage/managgetenant/ManageTenantList.vue